import { deleteWaiverTemplate } from "../../api/historyService";

export const useDeleteWaiverTemplate = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteWaiverTemplate(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete waiver template:", error);
            throw error;
        }
    };

    return { remove };
};